import React, { RefObject, useEffect, useState } from 'react';
import Checkbox from '../checkbox/Checkbox';
import { ICheckbox } from '../SaveInstrumentCheckbox.types';
import { CheckboxWrapper, LineBreak, Wrapper } from './DesktopSaveInstrumentCheckbox.styles';

function DesktopSaveInstrumentCheckbox(props: ICheckbox) {
  const { classNamePrefix } = props;
  const [checkboxWrapperHeight, setCheckboxWrapperHeight] = useState<number>(0);
  const checkboxWrapperRef: RefObject<HTMLDivElement> = React.createRef();

  useEffect(() => {
    if (checkboxWrapperRef.current) {
      setCheckboxWrapperHeight(checkboxWrapperRef.current.clientHeight);
    }
  }, [checkboxWrapperRef]);

  return (
    <Wrapper id="desktop-save-instrument-checkbox" height={checkboxWrapperHeight}>
      <CheckboxWrapper ref={checkboxWrapperRef}>
        <LineBreak className={`${classNamePrefix}-line-break`} />
        <Checkbox {...props} />
      </CheckboxWrapper>
    </Wrapper>
  );
}

export default DesktopSaveInstrumentCheckbox;
